export default "__VITE_ASSET__DTx$YTtW__"